var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$route.name !== 'Contact')?_c('router-link',{staticClass:"fabContact",attrs:{"to":"/contact","aria-label":"Contactez-nous"}},[_c('span',{staticClass:"fabLabel"},[_vm._v(_vm._s(_vm.$t('contact.fab')))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }